import { Inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ENVIRONMENT, ChatProviders, PARAMS, STORAGE_KEYS } from 'src/app/_constants/app.constants';
import { AuthService } from "src/app/_services/api/auth/auth.service";
import { LoggerService } from 'src/app/_services/ui/logger/logger.service';
import { SESSION_STORAGE_SERVICE } from 'src/app/_services/session/session.service'; 
import { StorageService } from 'ngx-webstorage-service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    @Inject(SESSION_STORAGE_SERVICE) public storage: StorageService,
    private authService: AuthService,
    private logger: LoggerService,
    ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Promise((resolve, reject) => {
      if (this.storage.has(STORAGE_KEYS.PARAMS)) {
        let params = this.storage.get(STORAGE_KEYS.PARAMS);
        if (next.paramMap?.has(PARAMS.ASSET_ID)) {
          params[PARAMS.ASSET_ID] = next.paramMap.has(PARAMS.ASSET_ID);
          this.storage.set(STORAGE_KEYS.PARAMS, params);
        }
        this.authService.asset = params[PARAMS.ASSET_ID] || false;
      }
      if (this.storage.has(STORAGE_KEYS.AUTH)) {
        const auth = this.storage.get(STORAGE_KEYS.AUTH);
        this.authService.active = auth.active;
        this.authService.token = auth.token;
        this.authService.isIAM = auth.isIAM;
        this.authService.isCisco = auth.isCisco;
        ENVIRONMENT.PROPERTIES.CHAT_PROVIDER = ChatProviders.WEBEX;
        ENVIRONMENT.PROPERTIES.CHAT_PROVIDER = ChatProviders.WEBEX;
        let chatProvider = "Cisco";
        this.logger.debug('AuthGuard.canActivate Chat provider is ', chatProvider);
      }
      if (!this.authService.token || next.paramMap?.has(PARAMS.ASSET_ID)) {
        this.logger.debug('AuthGuard.canActivate auth', this);
        this.authService.auth().then(() => {
          this.logger.debug('AuthGuard.canActivate store', this);
          this.storage.set(STORAGE_KEYS.AUTH, {
            active: this.authService.active,
            token: this.authService.token,
            isIAM: this.authService.isIAM,
            isCisco: this.authService.isCisco
          });
        }).catch(e => {
          this.logger.debug('AuthGuard.canActivate catch', e, this);
        }).finally(() => {
          return resolve(true);
        })
      } else {
        this.logger.debug('AuthGuard.canActivate authed', this);
        return resolve(true);
      }
    })
  }

}
